<script lang="ts" setup>
import { LOCALE_CODE } from '@pkg/config/languages/localeCodes';
import type { PageSeo } from '@pkg/sanity-utils/types/seo';
import type { ModularBlock } from '@pkg/sanity-utils/types/modularContentBlocks';
import ModularBlocksRenderer from '@pkg/modular-blocks/frontend/ModularBlocksRenderer.vue';

/**
 * @todo(jamie@hexdigital.com): Better define this Interface with regard to other interfaces, i.e. PageContent.
 * See: https://github.com/too-good-to-go/mkt-brochure-website/pull/34#discussion_r1444747567
 */
const props = defineProps<{
  content?: {
    _type: string,
    content: Array<ModularBlock>,
    pageVisibility: string,
    seoSocial: PageSeo,
    slug: string,
    language: LOCALE_CODE,
    _translations: Array<{ title: string; slug: string; language: LOCALE_CODE }>,
    [key: string]: any
  },
}>();

const { locale } = useI18n();

useHead({
  link: computed(() =>
    [...(locale.value === LOCALE_CODE.JA ? [{ rel: 'stylesheet', href: '/japan-override.css' }] : [])],
  ),
  bodyAttrs: {
    class: computed(() => {
      const firstContentBlock = props.content?.content?.[0];
      return firstContentBlock ? `first-block-theme--${firstContentBlock?.theme}` : '';
    }),
  },
});
</script>

<template>
  <ModularBlocksRenderer :blocks="props.content?.content" type="outer" enable-metrics />
</template>
